import { useTranslation } from "react-i18next";
import type { SearchSnippet as Snippet } from "src/api/search";
import { highlightSnippet } from "src/helpers/highlightSearch";

import { snippetLabel } from "./searchSections";

type SearchSnippetProps = {
	snippet: Snippet;
};

// „gdzie znaleziono” + fragment z podświetlonym trafieniem
export function SearchSnippet({ snippet }: SearchSnippetProps) {
	const { t } = useTranslation();

	return (
		<span className="global-search__snippet">
			<span className="global-search__snippet-source">
				{snippetLabel(snippet.source, t)}
			</span>
			<span className="text-ellipsis-1">{highlightSnippet(snippet)}</span>
		</span>
	);
}
